<template>
  <div class="link-nav">
    <b-modal
      id="modal-logout"
      centered
      title="Confirm Exit"
      ok
      ok-variant="success"
      @cancel="hide2nd()"
      cancel-variant="danger"
      @ok="loggingOut()"
    >
      <template v-slot:modal-ok> Yes, Logout </template>
      <p>Are You sure you want to Logout?</p>
    </b-modal>

    <div :class="navbody" class="pr-0 pb-3 pb-5 mt-1 pl-3">
      <b-link :to="{ name: 'adminhome' }">
        <img src="@/assets/logo.png" class="dash-logo" />
      </b-link>

      <b-link class="dashlink mactive" active-class="mactive" :to="{ name: 'dashhome' }"
        >Main Home</b-link
      >

      <b-link
        class="dashlink"
        v-if="fetchRole('topics')"
        active-class="active"
        @click="showdl1 = !showdl1"
      >
        <span class="mt-2 link-flex-1">Topics</span>
        <b-icon-caret-down-fill
          v-if="showdl1 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl1 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl1">
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('topics')"
          :to="{ name: 'addtopics' }"
          >Add Topics</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('topics')"
          :to="{ name: 'listtopics' }"
          >Edit Topics</b-link
        >
      </div>

      <b-link
        class="dashlink"
        v-if="fetchRole('questions') || fetchRole('stockingstats')"
        active-class="active"
        @click="showdl2 = !showdl2"
      >
        <span class="mt-2 link-flex-1">Test Questions</span>
        <b-icon-caret-down-fill
          v-if="showdl2 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl2 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl2">
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('questions')"
          :to="{ name: 'uploadquestion' }"
          >Upload Questions</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('questions')"
          :to="{ name: 'listquestion' }"
          >Uploaded Questions</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('stockingstats')"
          :to="{ name: 'stockingstat' }"
          >Check Stocking Statistics</b-link
        >
      </div>

      <b-link
        class="dashlink"
        v-if="fetchRole('category')"
        active-class="active"
        @click="showdl3 = !showdl3"
      >
        <span class="mt-2 link-flex-1">Test Categories</span>
        <b-icon-caret-down-fill
          v-if="showdl3 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl3 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl3">
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('category')"
          :to="{ name: 'addCategories' }"
          >Create Test Categories</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('category')"
          :to="{ name: 'listCategories' }"
          >Edit Test Categories</b-link
        >
      </div>

      <b-link
        class="dashlink"
        v-if="fetchRole('institution')"
        active-class="active"
        @click="showdl4 = !showdl4"
      >
        <span class="mt-2 link-flex-1">Test Institutions</span>
        <b-icon-caret-down-fill
          v-if="showdl4 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl4 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl4">
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('institution')"
          :to="{ name: 'addinstitution', query: { domain : 'base'} }"
          >Create Test Institution</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('institution')"
          :to="{ name: 'listinstitution' }"
          >Edit Test Institutions</b-link
        >
      </div>

      <b-link
        class="dashlink"
        v-if="fetchRole('testspace')"
        active-class="active"
        @click="showdl5 = !showdl5"
      >
        <span class="mt-2 link-flex-1">Testspaces and Competitions</span>
        <b-icon-caret-down-fill
          v-if="showdl5 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl5 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl5">
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('testspace')"
          :to="{ name: 'createtestspaces' }"
          >Create Testspace/Competition</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('testspace')"
          :to="{ name: 'listtestspaces' }"
          >View Testspaces</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('testspace')"
          :to="{ name: 'listcompetition' }"
          >View Competitions</b-link
        >
      </div>

      <!-- <b-link
        class="dashlink"
        v-if="fetchRole('testspace')"
        active-class="active"
        @click="showdl10 = !showdl10"
      >
        <span class="mt-2 link-flex-1">Competitions</span>
        <b-icon-caret-down-fill
          v-if="showdl10 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl10 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link> -->
      <div class="dropdown-links" v-if="showdl10">
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('testspace')"
          :to="{ name: 'createcompetition' }"
          >Create Competition</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('testspace')"
          :to="{ name: 'listcompetition' }"
          >View Competitions</b-link
        >
      </div>

      <b-link
        class="dashlink"
        v-if="
          fetchRole('ambassadors') ||
          fetchRole('partnerships') ||
          fetchRole('coupons') ||
          fetchRole('discount')
        "
        active-class="active"
        @click="showdl6 = !showdl6"
      >
        <span class="mt-2 link-flex-1">Promotions & Marketing</span>
        <b-icon-caret-down-fill
          v-if="showdl6 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl6 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl6">
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('ambassadors')"
          :to="{ name: 'addambassadors' }"
          >Add Ambassadors</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('ambassadors')"
          :to="{ name: 'ambassadorstats' }"
          >Ambassadors Statistics</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('ambassadors')"
          :to="{ name: 'payouts' }"
          >Ambassador Payouts</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('partnerships')"
          :to="{ name: 'createpartnerships' }"
          >Create Partnerships</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('partnerships')"
          :to="{ name: 'allpartnerships' }"
          >All Partnerships</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('coupons')"
          :to="{ name: 'coupons' }"
          >Create Coupons</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('coupons')"
          :to="{ name: 'viewcoupons' }"
          >All Coupons</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('discount')"
          :to="{ name: 'discount' }"
          >Platform settings (Discount & Free season)</b-link
        >
      </div>

      <b-link
        class="dashlink"
        v-if="
          fetchRole('ambassadors') || fetchRole('partnerships') || fetchRole('coupons')
        "
        active-class="active"
        @click="showdl9 = !showdl9"
      >
        <span class="mt-2 link-flex-1">Users & Finance Management</span>
        <b-icon-caret-down-fill
          v-if="showdl9 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl9 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl9">
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('ambassadors')"
          :to="{ name: 'allusers' }"
          >All users</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('ambassadors')"
          :to="{ name: 'payouts' }"
          >Premium users</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('partnerships')"
          :to="{ name: 'partnerships' }"
          >Users Transactions</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('coupons')"
          :to="{ name: 'coupons' }"
          >Financial Analysis</b-link
        >
      </div>

      <b-link
        class="dashlink"
        v-if="fetchRole('contents') || fetchRole('blog') || fetchRole('notifications')"
        active-class="active"
        @click="showdl7 = !showdl7"
      >
        <span class="mt-2 link-flex-1">Content Management</span>
        <b-icon-caret-down-fill
          v-if="showdl7 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl7 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl7">
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('contents')"
          :to="{ name: 'addcontent' }"
          >Add Contents</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('contents')"
          :to="{ name: 'listcontents' }"
          >View Contents</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('campaigns')"
          :to="{ name: 'campaigns' }"
          >Campaigns</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('notifications')"
          :to="{ name: 'addnotifications' }"
          >Add Notifications</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('notifications')"
          :to="{ name: 'listnotifications' }"
          >View Notifications</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('blog')"
          :to="{ name: 'addblogpost' }"
          >Add a Blog Post</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('blog')"
          :to="{ name: 'listblogposts', query: { page: 1 } }"
          >Edit a Blog Post</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('blog')"
          :to="{ name: 'listblogdrafts', query: { page: 1 } }"
          >Blog Drafts</b-link
        >
      </div>

      <b-link
        class="dashlink"
        v-if="fetchRole('orgspace') || fetchRole('createadmins') || fetchRole('metrics')"
        active-class="active"
        @click="showdl8 = !showdl8"
      >
        <span class="mt-2 link-flex-1">Organization Functions</span>
        <b-icon-caret-down-fill
          v-if="showdl8 == false"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-down-fill>
        <b-icon-caret-left-fill
          v-if="showdl8 == true"
          class="mt-2 link-flex-2"
          font-scale="1"
        ></b-icon-caret-left-fill>
      </b-link>
      <div class="dropdown-links" v-if="showdl8">
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('orgspace')"
          :to="{ name: 'configureorganization' }"
          >Configure Organization Space</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('createadmins')"
          :to="{ name: 'createadmins' }"
          >Create Admin roles to Organization</b-link
        >
        <b-link
          class="dashlink-en"
          active-class="active"
          v-if="clearance != 'Normal' && fetchRole('metrics')"
          :to="{ name: 'companymetrics' }"
          >Quicktest Metrics</b-link
        >
      </div>

      <b-link class="dashlink-en" active-class="active" @click="confirmLogout()"
        >Log Out</b-link
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: ["clearance", "level", "navbody"],
  data() {
    return {
      showdl1: false,
      showdl2: false,
      showdl3: false,
      showdl4: false,
      showdl5: false,
      showdl6: false,
      showdl7: false,
      showdl8: false,
      showdl9: false,
      showdl10: false,
    };
  },
  computed: {
    activeRoute() {
      let matchArray = this.$route.matched.findIndex((x) => x.name == "testspaces");
      //console.log(matchArray)
      return matchArray != -1 ? "active" : "inactive";
    },
    activeDashRoute() {
      let matchArray = this.$route.matched.findIndex((x) => x.name == "dashhome");
      //console.log(matchArray)
      return matchArray != -1 ? "active" : "inactive";
    },
    ...mapState({
      userdet: (state) => state.loginmaster.details,
      plan: (state) => state.loginmaster.details.plan,
    }),
  },
  methods: {
    ...mapActions(["logOut"]),
    confirmLogout() {
      this.$bvModal.show("modal-logout");
    },
    loggingOut() {
      let now = new Date();
      now.setFullYear(now.getFullYear() - 20);
      document.cookie = `remember=;expires=${now.toUTCString()}`;
      document.cookie = `qid=;expires=${now.toUTCString()}`;
      this.logOut().then(() => {
        this.$router.push({
          name: "login",
        });
      });
    },
    hide2nd() {
      this.$bvModal.hide("modal-logout");
    },
    fetchRole(role) {
      // if(this.userdet.roles?.length > 0)
      let exist = this.userdet.roles?.findIndex((x) => x == role);

      if (exist == -1) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>

.dashside {
  background-color: white;
  margin-top: -18px;
  height: 100%;
  min-height: 100px;
}
.dashtext {
  font-size: 18px;
  font-family: "Times New Roman", Times, serif;
  color: white;
}

/*.dashlink {
  display: flex;
  font-size: 16px;
  margin-top: 1rem;
  text-decoration: none;
  color: black;
  padding: 3px;
  border-bottom: 1px solid rgba(237, 228, 228, 0.412)
}*/
.dashlink {
  display: flex;
  font-size: 0.9rem;
  margin-top: 0.2rem;
  text-decoration: none;
  color: white;
  padding: 0.8rem;
  border-radius: 10px 10px;
  border-bottom: 1px solid rgba(237, 228, 228, 0.412);
}
.dashlink:hover {
  background-color: #3a477c;
}
.dashlink-en {
  display: block;
  font-size: 0.9rem;
  margin-top: 0.2rem;
  text-decoration: none;
  color: white;
  padding: 0.8rem;
  padding-left: 1.3rem;
}
.dashlink-en:hover {
  background-color: #3a477c;
}
.dropdown-links {
  background-color: #263056;
  border-radius: 10px 10px;
}
.link-flex-1 {
  width: 90%;
}
.link-flex-2 {
  width: 10%;
}

.active {
  border-right: 14px solid #263056;

}
.mactive {
  color: gray;
  border-right: 15px solid rgba(242, 20, 20, 0.808);
}
.dash-logo {
  width: 60%;
}

@media screen and (min-width: 999px) {
  .sbb {
    display: none;
  }
}

@media (max-width: 999px) {
  
}
@media (max-width: 999px) {
  .navbody {
    background: #263056;
  }

  .logo-wrapper {
    margin-top: 10px;
  }
}
</style>
